query peopleSearch(
  $searchTerms: [String]
  $filter: InsightFilter
  $searchAfterId: [String]
  $size: Int
  $includeTotalCount: Boolean
) {
  result: searchPeople(
    searchTerms: $searchTerms
    filter: $filter
    searchAfterId: $searchAfterId
    size: $size
    includeTotalCount: $includeTotalCount
  ) {
    totalCount
    searchAfterId
    people {
      aggregateId
      bands
      employeeId
      firstName
      surname
      preferredName
      jobTitle
      gender
      avatar
      fte
    }
  }
}

query getPeopleCsvExport($searchTerms: [String], $filter: InsightFilter) {
  csvExport: getPeopleCsvExport(searchTerms: $searchTerms, filter: $filter) {
    content
  }
}
